const URL_VALIDATION_ERROR = 'Formato incorreto';

const ATTACHMENT_LINK_ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Mirrors the backend's `isSafeAttachmentUrl` in training-control-pdf.shared.ts:
 * user-supplied attachment URLs (e.g. an external instructor's curriculum) must
 * be protocol-checked before being bound to an `href`, or a `javascript:`/`data:`
 * value stored by one user runs in another user's session when they click it.
 */
export function isSafeAttachmentUrl(url: string): boolean {
  try {
    return ATTACHMENT_LINK_ALLOWED_PROTOCOLS.has(new URL(url).protocol);
  } catch {
    return false;
  }
}

export function formatUrl(url: string): string {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return '';

  if (!/^https?:\/\//i.test(trimmedUrl)) {
    return `https://${trimmedUrl}`;
  }
  return trimmedUrl;
}

export function validateUrl(url: string): { isValid: boolean | null; error: string } {
  const urlToValidate = formatUrl(url);

  if (!urlToValidate) {
    return { isValid: null, error: '' };
  }

  try {
    const urlObject = new URL(urlToValidate);
    const hostname = urlObject.hostname;

    if (!hostname.includes('.')) {
      return { isValid: false, error: URL_VALIDATION_ERROR };
    }

    const parts = hostname.split('.');
    const tld = parts[parts.length - 1];

    if (parts.length < 2 || tld.length < 2 || !/^[a-zA-Z]{2,}$/.test(tld)) {
      return { isValid: false, error: URL_VALIDATION_ERROR };
    }

    const domainPart = parts[0];
    if (
      !domainPart ||
      domainPart.length === 0 ||
      !/^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(domainPart)
    ) {
      return { isValid: false, error: URL_VALIDATION_ERROR };
    }

    return { isValid: true, error: '' };
  } catch {
    return { isValid: false, error: URL_VALIDATION_ERROR };
  }
}
